import type { DataLayer } from '../DataLayer';
import { isNullified } from '../mappers/nullify';

const searchPrefix = 'Seek : Job Search :';
const jobPrefix = 'Seek : Job :';
const domainRegex = /^(?:https?:\/\/)?(?:[^@\n]+@)?([^:\/\n]+)/i;

const stripSpaceAndLowerCase = (value: string): string =>
  value.replace(/[^a-z\d]/gi, '').toLowerCase();

const convertSpaceToPlusAndLowerCase = (value: string): string =>
  value.replace(/[^a-z\d]/gi, '+').toLowerCase();

export default (state: DataLayer, isApplyClick: boolean = false): DataLayer => {
  const {
    seekAdvertiserId,
    advertiserName,
    jobClassificationId,
    jobSubClassificationId,
    searchDateRange,
    searchWorkTypeIds,
    searchRemoteOptions,
    classificationId,
    subClassificationId,
    searchSalaryRange,
    searchSalaryType,
    searchKeyword,
    sortedBy,
    searchGraduate,
    searchLocation,
    searchArea,
  } = state;

  const actions: string[] = [];
  const interests: string[] = [];
  const userGenerated: string[] = [];

  if (isApplyClick) {
    actions.push(`${jobPrefix} Application Start`);
  }

  if (seekAdvertiserId) {
    interests.push(`${searchPrefix} Advertiser ID : ${seekAdvertiserId}`);
  }

  if (advertiserName) {
    interests.push(`${searchPrefix} Advertiser : ${advertiserName} –`);
    // The '–' is to keep the interests consistent across new JDP and classic
  }

  if (jobClassificationId) {
    interests.push(`${searchPrefix} Industry : ${jobClassificationId}`);
  }

  if (jobSubClassificationId) {
    interests.push(`${searchPrefix} Occupation : ${jobSubClassificationId}`);
  }

  if (searchDateRange) {
    interests.push(`${searchPrefix} Date Range : ${searchDateRange}`);
  }

  if (searchWorkTypeIds && !isNullified(searchWorkTypeIds)) {
    searchWorkTypeIds.split(',').forEach((workType) => {
      interests.push(`${searchPrefix} Work Type : ${workType}`);
    });
  }

  if (searchRemoteOptions && !isNullified(searchRemoteOptions)) {
    searchRemoteOptions.split(',').forEach((workArrangement) => {
      interests.push(`${searchPrefix} Work Arrangement : ${workArrangement}`);
    });
  }

  if (classificationId && !isNullified(classificationId)) {
    classificationId.split(',').forEach((classification) => {
      interests.push(`${searchPrefix} Industry : ${classification}`);
    });
  }

  if (subClassificationId && !isNullified(subClassificationId)) {
    subClassificationId.split(',').forEach((subClassification) => {
      interests.push(`${searchPrefix} Occupation : ${subClassification}`);
    });
  }

  if (searchSalaryRange && searchSalaryRange !== 'NULL') {
    const [salaryMin, salaryMax] = searchSalaryRange.split('-');

    if (salaryMin && salaryMin !== 'NULL') {
      interests.push(`${searchPrefix} Salary Min : ${salaryMin}`);
    }

    if (salaryMax && salaryMax !== 'NULL') {
      interests.push(`${searchPrefix} Salary Max : ${salaryMax}`);
    }
  }

  if (searchSalaryType) {
    const salaryType = stripSpaceAndLowerCase(searchSalaryType);

    interests.push(`${searchPrefix} Salary Type : ${salaryType}`);
  }

  if (searchKeyword && !isNullified(searchKeyword)) {
    const keywords = convertSpaceToPlusAndLowerCase(searchKeyword);

    userGenerated.push(`${searchPrefix} Keywords : ${keywords}`);
  }

  if (searchLocation) {
    const location = stripSpaceAndLowerCase(searchLocation);

    interests.push(`${searchPrefix} Location : ${location}`);
  }

  if (searchArea) {
    const area = stripSpaceAndLowerCase(searchArea);

    interests.push(`${searchPrefix} Area : ${area}`);
  }

  if (sortedBy) {
    const sortMode = stripSpaceAndLowerCase(sortedBy);

    interests.push(`${searchPrefix} Sort Mode : ${sortMode}`);
  }

  if (searchGraduate) {
    interests.push(`${searchPrefix} Graduate Search : true`);
  }

  if (typeof document !== 'undefined') {
    const { domain, referrer } = document;

    if (domain) {
      interests.push(`${domain} : Total Site Traffic`);
    }

    if (referrer) {
      const referrerDomain = domainRegex.exec(referrer);

      if (referrerDomain) {
        interests.push(`${referrerDomain[1] ?? 'null'} : Referrer Site`);
      }
    }
  }

  return {
    lotameActions: actions,
    lotameInterests: interests,
    lotameUserGenerated: userGenerated,
  };
};
